import { render, staticRenderFns } from "./community_tag.vue?vue&type=template&id=34c1429a&scoped=true&"
import script from "./community_tag.vue?vue&type=script&lang=js&"
export * from "./community_tag.vue?vue&type=script&lang=js&"
import style0 from "./community_tag.vue?vue&type=style&index=0&id=34c1429a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1429a",
  null
  
)

export default component.exports